/**
 * Utility functions for handling file uploads to R2 storage
 */

/**
 * Uploads a file to R2 storage using a presigned URL
 * This uses the native fetch API which handles presigned URLs better than axios
 * 
 * @param presignedUrl The presigned URL to upload to
 * @param file The file to upload
 * @returns A promise that resolves when the upload is complete
 */
export const uploadToR2 = async (presignedUrl: string, file: File): Promise<Response> => {
  try {
    // Use the native fetch API instead of axios for better compatibility with presigned URLs
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!response.ok) {
      // Log detailed error information
      const errorText = await response.text();
      console.error('R2 upload failed:', {
        status: response.status,
        statusText: response.statusText,
        errorText,
      });
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error('Error in uploadToR2:', error);
    throw error;
  }
};
